/* eslint-disable no-useless-catch */
import { API } from "../api";
import { REGIONS_URL } from "../constants/url.constant";

export const ADD_REGION = "ADD_REGION";
export const GET_REGIONS = "GET_REGIONS";
export const DELETE_REGION = "DELETE_REGION";
export const UPDATE_REGION = "UPDATE_REGION";

export const addRegion = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(REGIONS_URL, data);
      dispatch(addRegionList(data));
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeRegion = (regionCode) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${REGIONS_URL}/${regionCode}`);
      dispatch(deleteRegion(regionCode));
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addRegionList = (data) => ({
  type: ADD_REGION,
  payload: data
});

export const updateRegion = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${REGIONS_URL}/${code}`, body);
      dispatch({ type: UPDATE_REGION, payload: { code, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const deleteRegion = (code) => ({
  type: DELETE_REGION,
  payload: code
});

export const getRegions = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(REGIONS_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_REGIONS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { regionTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_REGIONS:
      return {
        ...state,
        regionTableColumns: payload.columns,
        regionTableRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_REGION:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        regionTableRows: [
          ...state.regionTableRows,
          { code: payload.code, name: payload.name }
        ]
      };
    case DELETE_REGION:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        regionTableRows: state.regionTableRows.filter(
          (region) => region.code !== payload
        )
      };
    case UPDATE_REGION:
      return {
        ...state,
        regionTableRows: state.regionTableRows.map((region) =>
          region.code === payload.code
            ? { "country.name": region["country.name"], ...payload }
            : region
        )
      };
    default:
      return state;
  }
}
